import { ref } from 'vue'

// Barre de progression globale pour les changements de route
export const routeProgressVisible = ref(false)
